// extracted by mini-css-extract-plugin
export var blink = "_6r-2";
export var cursor = "_6r-1";
export var reactMarkdown = "_6r-3";
export var streamingText = "_6r-0";